import React, { useContext, useState } from 'react';
import {Link, useLocation} from 'react-router-dom';

import {Dropdown, Nav} from 'react-bootstrap';

import NavbarDropdown from './NavbarDropdown';

import routeMenu from 'config/app-route-menu';
import routeAllowed from 'config/app-route-allowed.jsx';
import AppContext from 'config/app-context';

import useAuthorization from 'hooks/useAuthorization.js';


const MenuItems = () => {
    const userType = useAuthorization();
    const location = useLocation(); // Hook para obtener la ubicación actual

    const { config: { navbarCollapsed, showBurgerMenu }, setConfig } = useContext(AppContext);
    const [activeItem, setActiveItem] = useState(null); // Estado para el elemento activo

    const handleDropdownItemClick = (path) => {
        setActiveItem(path); // Establece el elemento activo
        if (navbarCollapsed) setConfig('navbarCollapsed', !navbarCollapsed);
        if (showBurgerMenu) setConfig('showBurgerMenu', !showBurgerMenu);
    };

    const checkUserRole = (item) => {
		const allowedRolesForItem = routeAllowed[item.path];
		try {
			return userType.some((element) => allowedRolesForItem.includes(element));	
		} catch(e) {}
	}
    
    const filteredMenu = routeMenu.filter((item) => {
		let isAllowed = checkUserRole(item);
		return isAllowed;
	});

	
    return (
        <>
            {filteredMenu.map((menuItem, index) => {
                if (menuItem.children) {
                    // Filtrar subrutas que el usuario puede ver
                     const filteredChildren = menuItem.children.filter((child) => checkUserRole(child));
                    
                    // Renderizar el dropdown solo si hay subrutas permitidas
                    return filteredChildren.length > 0 ? (
                        <NavbarDropdown key={index} title={menuItem.title} icon={menuItem.icon}>
                            {filteredChildren.map((child, childIndex) => (
                                <Dropdown.Item
                                    key={childIndex}
                                    as={Link}
                                    className={activeItem === child.path || location.pathname === child.path ? 'link-600 active' : 'text-500'}
                                    to={child.path}
                                    onClick={() => handleDropdownItemClick(child.path)} >
                                    {child.title}
                                </Dropdown.Item>
                            ))}
                        </NavbarDropdown>
                    ) : null; // No renderizar dropdown si no hay subrutas permitidas
                } else {
                    return (
                        <Nav style={{ justifyContent: 'center', padding: '8px 0.5rem' }} className="flex-column" as="ul" key={index}>
                            <Nav.Item key={index}>
                                <Dropdown.Item
                                    className={activeItem === menuItem.path || location.pathname === menuItem.path ? 'link-600 active' : 'text-500'} // Clase activa si es el elemento seleccionado
                                    to={menuItem.path}
                                    as={Link} 
                                    onClick={() => handleDropdownItemClick(menuItem.path)} >
                                    <i className={menuItem.icon}></i> {menuItem.title}
                                </Dropdown.Item>
                            </Nav.Item>
                        </Nav>
                    );
                }
            })}
        </>
    );
};

export default MenuItems;